import React from 'react';
import BpmSlider from './BpmSlider.js';
import MixButtons from  './MixButtons.js';
import ClockComponent from 'components/toolbar/ClockComponent.js';
import RollButtons from './RollButtons.js';
import ReactBootstrapSlider from 'react-bootstrap-slider';

export default ({sequencerEngine, children}) => {
    return (
        <div className="mixer-toolbar-container">
          <div className="mixer-toolbar">
            <BpmSlider sequencerEngine={sequencerEngine}/>
            <MixButtons sequencerEngine={sequencerEngine}/>
            <ClockComponent sequencerEngine={sequencerEngine.headSequencerEngine}/>
            <RollButtons sequencerEngine={sequencerEngine}/>
          </div>
          {children}
        </div>
    );
};
